// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__s_3t_","buzzfeed":"sidebar_buzzfeed__F7Tm_","buzzfeed_news":"sidebar_buzzfeed_news__FIuY2","sidebarBranded":"sidebar_sidebarBranded__DD5zB"};